import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import context from '../context/recipesContext';

const IngredientCard = ({ ingredient, index, type }) => {
  const BASE_URL_MEAL_IMG = 'https://www.themealdb.com/images/ingredients';
  const BASE_URL_DRINK_IMG = 'https://www.thecocktaildb.com/images/ingredients';
  const { setFilterDrinks, setFilterFoods } = useContext(context);
  const history = useHistory();

  let URL;
  let ingredientName;
  if (type === 'foods') {
    const { strIngredient } = ingredient;
    ingredientName = strIngredient;
    URL = `${BASE_URL_MEAL_IMG}/${strIngredient}-Small.png`;
  } else {
    const { strIngredient1 } = ingredient;
    ingredientName = strIngredient1;
    URL = `${BASE_URL_DRINK_IMG}/${strIngredient1}-Small.png`;
  }

  const handleClick = () => {
    if (type === 'foods') {
      setFilterFoods({ value: ingredientName, filter: 'ingredient' });
      history.push('/foods');
    } else {
      setFilterDrinks({ value: ingredientName, filter: 'ingredient' });
      history.push('/drinks');
    }
  };

  return (
    <button
      className="ingredient-card"
      onClick={ handleClick }
      data-testid={ `${index}-ingredient-card` }
      type="button"
    >
      <p data-testid={ `${index}-card-name` } className="ingredient-name">
        {ingredientName}
      </p>
      <div className="image-container">
        <img
          data-testid={ `${index}-card-img` }
          className="ingredient-img"
          src={ URL }
          alt={ ingredientName }
        />
      </div>
    </button>
  );
};

IngredientCard.propTypes = {
  index: PropTypes.number.isRequired,
  ingredient: PropTypes.shape({
    strIngredient: PropTypes.string,
    strIngredient1: PropTypes.string,
  }),
  type: PropTypes.string.isRequired,
};

IngredientCard.defaultProps = {
  ingredient: PropTypes.shape({
    strIngredient: '',
    strIngredient1: '',
  }).isRequired,
};

export default IngredientCard;
